import { MODIFIER_ITEM_KEY, ModifierItemState } from './modifier-item-reducer';

export enum MODIFIER_ITEM_ACTION_TYPE {
  SET_MODIFIER_ITEM_STATE = 'SET_MODIFIER_ITEM_STATE',
  CALL_MODIFIER_ITEMS = 'CALL_MODIFIER_ITEMS',
}

export type ModifierItemPaginationParams = {
  page?: number;
  limit?: number;
  keyword?: string;
};

export interface IPaginationMeta {
  itemCount: number;
  totalItems: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
}

export type SetModifierItemStateAction<KeyName extends keyof ModifierItemState> = {
  type: MODIFIER_ITEM_ACTION_TYPE.SET_MODIFIER_ITEM_STATE;
  payload: { key: KeyName; value: ModifierItemState[KeyName] };
};

export interface ModifierItem {
  menuModifierItemId: number;
  menuModifierItemName: string;
  menuModifierItemPrice: number;
  menuModifierItemIsOffline: boolean;
  menuModifierItemNameEN?: string;
  menuModifierItemSKUId?: string;
}

export type CallModifierItemsAction = {
  type: MODIFIER_ITEM_ACTION_TYPE.CALL_MODIFIER_ITEMS;
  payload?: ModifierItemPaginationParams;
};

export type ModifierItemActions = SetModifierItemStateAction<MODIFIER_ITEM_KEY> | CallModifierItemsAction;
